import axios from 'axios'
import { The, createJsonData, createFormData } from 'helpers/generalHelpers'
import { HTTP } from 'types'
import { APIURL, config, getCurrentWorkspace } from './_utils'

const workspace = getCurrentWorkspace()

// // #region USER FORM

export const userForms = {
  create: (formData) =>
    The(
      axios.post(
        `${APIURL}/v4/user-forms/`,
        formData,
        config({
          contentType: HTTP.ContentTypes.JSON,
          workspace,
        })
      )
    ),
  getOne: (userFormSlug) =>
    The(
      axios.get(
        `${APIURL}/v4/user-forms/${userFormSlug}/`,
        config({ workspace })
      )
    ),

  getAll: (params = {}) =>
    The(axios.get(`${APIURL}/v4/user-forms/`, config({ params, workspace }))),

  update: (userFormSlug, formData) =>
    The(
      axios.patch(
        `${APIURL}/v4/user-forms/${userFormSlug}/`,
        formData,
        config({
          contentType: HTTP.ContentTypes.JSON,
          workspace,
        })
      )
    ),

  getUserOfUserForm: (userFormSlug) =>
    The(
      axios.get(
        `${APIURL}/v4/user-forms/${userFormSlug}/`,
        config({ workspace })
      )
    ),

  addUserToUserForm: (userFormSlug, formData) =>
    The(
      axios.post(
        `${APIURL}/v4/forms/${userFormSlug}/submit-user-form/`,
        formData,
        config({ contentType: HTTP.ContentTypes.JSON, workspace })
      )
    ),

  updateUserOfUserForm: (userSlug, formData) =>
    The(
      axios.patch(
        `${APIURL}/v4/user-form-rows/${userSlug}/`,
        formData,
        config({ contentType: HTTP.ContentTypes.JSON, workspace })
      )
    ),
}
// #endregion USER FORM
